import { create } from 'zustand';
import {
	getShowTanstackQueryDevTools,
	getShowTanstackRouterDevTools,
	setShowTanstackQueryDevTools,
	setShowTanstackRouterDevTools,
} from './utils';

export type DevToolsState = {
	showTanstackQueryDevTools: boolean;
	toggleTanstackQueryDevTools: () => void;
	showTanstackRouterDevTools: boolean;
	toggleTanstackRouterDevTools: () => void;
};

export const useDevTools = create<DevToolsState>((set, get) => ({
	showTanstackQueryDevTools: getShowTanstackQueryDevTools(),
	toggleTanstackQueryDevTools: () => {
		const { showTanstackQueryDevTools } = get();

		const newShowTanstackQueryDevTools = !showTanstackQueryDevTools;
		setShowTanstackQueryDevTools(newShowTanstackQueryDevTools);

		set({
			showTanstackQueryDevTools: newShowTanstackQueryDevTools,
		});
	},
	showTanstackRouterDevTools: getShowTanstackRouterDevTools(),
	toggleTanstackRouterDevTools: () => {
		const { showTanstackRouterDevTools } = get();

		const newShowTanstackRouterDevTools = !showTanstackRouterDevTools;
		setShowTanstackRouterDevTools(newShowTanstackRouterDevTools);

		set({
			showTanstackRouterDevTools: newShowTanstackRouterDevTools,
		});
	},
}));
